import { Formik, Form, Field, ErrorMessage } from 'formik';
import { signupSchema } from './authSchemas';
import apiServices from '../../services/service';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Signup = ({ onLogin }) => {

      const navigate = useNavigate();
    const handleRegisterUser = async (values) => {
        console.log("Signup values 👉", values);
        try {
            const response = await apiServices.registerUser(values);
            if (response?.status === 200) {
                // navigate("/login");
                return;
            }
            toast.warning("Invalid username or password");
            console.log('Register success', response);
            onLogin(); // move back to login
        } catch (error) {
            console.error('Register failed:', error);
        }
    };

  return (
    <div className="loginBox">
     <Formik
                initialValues={{
                    firstName: '',
                    lastName: '',
                    mobile: '',
                    username: '',
                    password: '',
                    // confirmPassword: '',
                }}
                validationSchema={signupSchema}
                onSubmit={handleRegisterUser}
            >
                {({ errors, touched, isSubmitting }) => (
                    <Form className="login-card" noValidate>
                        <h2>Register</h2>

                        <div className="row">
                            <div className="col-6">
                                <Field
                                    name="firstName"
                                    placeholder="First Name"
                                    className={errors.firstName && touched.firstName ? 'errorField' : ''}
                                />
                                <ErrorMessage name="firstName" component="div" className="errorMessage" />
                            </div>

                            <div className="col-6">
                                <Field
                                    name="lastName"
                                    placeholder="Last Name"
                                    className={errors.lastName && touched.lastName ? 'errorField' : ''}
                                />
                                <ErrorMessage name="lastName" component="div" className="errorMessage" />
                            </div>
                        </div>

                        <Field
                            name="mobile"
                            placeholder="Mobile Number"
                            className={errors.mobile && touched.mobile ? 'errorField' : ''}
                        />
                        <ErrorMessage name="mobile" component="div" className="errorMessage" />

                        <Field
                            name="username"
                            placeholder="Email"
                            className={errors.username && touched.username ? 'errorField' : ''}
                        />
                        <ErrorMessage name="username" component="div" className="errorMessage" />

                        <Field
                            type="password"
                            name="password"
                            placeholder="Password"
                            className={errors.password && touched.password ? 'errorField' : ''}
                        />
                        <ErrorMessage name="password" component="div" className="errorMessage" />

                        <Field
                            type="password"
                            name="confirmPassword"
                            placeholder="Confirm Password"
                            className={errors.confirmPassword && touched.confirmPassword ? 'errorField' : ''}
                        />
                        <ErrorMessage name="confirmPassword" component="div" className="errorMessage" />

                        <button
                            type="submit"
                            className="login-btn"
                        // disabled={isSubmitting}
                        >
                            Create Account
                        </button>

                        <p className="signup-text">
                            Already have an account?{' '}
                            <span className="link" onClick={onLogin}>
                                Login
                            </span>
                        </p>
                    </Form>
                )}
            </Formik>
    </div>
  );
};

export default Signup;
